const VERSION = '2.0.22b'
export default VERSION
